import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    meta: {
      title: ''
    },
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: ''
    },
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: ''
    },
    component: () => import(/* webpackChunkName: "home" */ '../views/Login.vue')
  },
  {
    path: '/user',
    name: 'User',
    meta: {
      title: ''
    },
    component: () => import(/* webpackChunkName: "home" */ '../views/User.vue')
  },
  {
    path: '/buy-car',
    name: 'BuyCar',
    component: () => import(/* webpackChunkName: "home" */ '../views/BuyCar.vue'),
    meta: { keepAlive: true, title: '' }
  },
  {
    path: '/sell-car',
    name: 'SellCar',
    meta: {
      title: ''
    },
    component: () => import(/* webpackChunkName: "car" */ '../views/SellCar.vue')
  },
  {
    path: '/car-brand-list',
    name: 'CarBrandList',
    meta: {
      title: ''
    },
    component: () => import(/* webpackChunkName: "car" */ '../views/CarBrandList.vue')
  },
  {
    path: '/car-detail',
    name: 'CarDetail',
    meta: {
      title: ''
    },
    component: () => import(/* webpackChunkName: "car" */ '../views/CarDetail.vue')
  },
  {
    path: '/check-report',
    name: 'CheckReport',
    meta: {
      title: ''
    },
    component: () => import(/* webpackChunkName: "car" */ '../views/CheckReport.vue')
  },
  {
    path: '/car-params',
    name: 'CarParams',
    meta: {
      title: ''
    },
    component: () => import(/* webpackChunkName: "car" */ '../views/CarParams.vue')
  },
  {
    path: '/news-detail',
    name: 'NewsDetail',
    component: () => import(/* webpackChunkName: "Home" */ '../views/NewsDetail.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import(/* webpackChunkName: "Home" */ '../views/News.vue')
  },
  {
    path: '/custom-page',
    name: 'CustomPage',
    component: () => import(/* webpackChunkName: "Home" */ '../views/CustomPage.vue')
  },
  {
    path: '/more-screen',
    name: 'MoreScreen',
    component: () => import(/* webpackChunkName: "Home" */ '../views/MoreScreen.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
